import * as React from 'react';
import { useThemeSwitcher } from 'react-css-theme-switcher';
import GlobalSearch from '../GlobalSearch';
import NavigationShortcuts from '../NavigationShortcuts';
import ShortcutHelp from '../ShortcutHelp';
import NavBar from './NavBar';
import PopupNavBar from './PopupNavBar';

type Props = {
  children?: React.ReactNode
};

export const Layout: React.FC<Props> = props => {
  const { status } = useThemeSwitcher();

  if (status !== 'loaded') {
    return <div>Loading...</div>;
  }

  return (<>
    {window.opener ? <PopupNavBar /> : <NavBar />}
    {window.opener ? <GlobalSearch buttonless /> : null}
    <ShortcutHelp />
    <NavigationShortcuts />
    <div className="container-fluid body-content px-1 px-md-2 px-lg-3">
      {props.children}
      <br />
      <footer>
        <p>&copy; {new Date().getFullYear()} - Load One LLC</p>
      </footer>
    </div>
  </>);
}

export const CustomerLayout: React.FC<Props> = props => {
  const { status } = useThemeSwitcher();

  if (status !== 'loaded') {
    return <div>Loading...</div>;
  }

  return <>
    <PopupNavBar />
    <div className="container-fluid body-content px-1 px-md-2 px-lg-3">
      {props.children}
      <br />
      <footer>
        <p>&copy; {new Date().getFullYear()} - Load One LLC</p>
      </footer>
    </div>
  </>;
}
